import { render, staticRenderFns } from "./RaceVideoHighlightsPane.vue?vue&type=template&id=a5696f2c&scoped=true"
import script from "./RaceVideoHighlightsPane.vue?vue&type=script&lang=ts"
export * from "./RaceVideoHighlightsPane.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoHighlightsPane.vue?vue&type=style&index=0&id=a5696f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5696f2c",
  null
  
)

export default component.exports